import { render } from "./LifeChurch.vue?vue&type=template&id=895c52e6"
import script from "./LifeChurch.vue?vue&type=script&lang=js"
export * from "./LifeChurch.vue?vue&type=script&lang=js"
script.render = render

export default script